import React, { Component } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import PageTitle from '../Misc/PageTitle';
import ContentLiveCard from '../Misc/ContentLiveCard';
import ContentStatsBar from '../Misc/ContentStatsBar';
import './Showcase.css';

import ToasterImg from '../../Assets/Img/msg-toaster.png';
import AirPollutionImg from '../../Assets/Img/air-pollution-checker-img.png';
import Angular2GoogleLoginImg from '../../Assets/Img/angular2-google-login-thumb.png';

const conceptIcons = {
  gesture: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" opacity="0.18" />
      <path d="M22 38c0-6 4-14 10-14s10 8 10 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="32" cy="20" r="3" fill="currentColor" />
    </svg>
  ),
  video: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="10" y="18" width="32" height="28" rx="4" stroke="currentColor" strokeWidth="2.5" />
      <path d="M42 26l14-6v24l-14-6V26z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
    </svg>
  ),
  exam: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="16" y="12" width="32" height="40" rx="4" stroke="currentColor" strokeWidth="2.5" />
      <path d="M24 24h16M24 32h16M24 40h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M40 38l3 3 6-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  inventory: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M12 24l20-10 20 10v22l-20 10-20-10V24z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M32 14v42M12 24l20 10 20-10" stroke="currentColor" strokeWidth="2" opacity="0.4" />
    </svg>
  ),
};

const projects = [
  {
    title: 'jQuery Message Toaster',
    category: 'plugin',
    categoryLabel: 'Plugin',
    desc: 'A non-blocking, customizable jQuery based notification toaster library with configurable options.',
    tech: [{ label: 'JavaScript', cls: 'js-label' }, { label: 'jQuery', cls: 'jquery-label' }],
    date: '01 Dec 2017',
    year: '2017',
    img: ToasterImg,
    demo: 'http://content.rudrakshpathak.com/toaster',
    github: 'https://github.com/rudrakshpathak/jquery-message-toaster',
    npm: 'https://www.npmjs.com/package/jquery-message-toaster',
  },
  {
    title: 'Air Pollution Checker',
    category: 'application',
    categoryLabel: 'Application',
    desc: 'City-wide vehicle emission and air pollution monitoring utility integrated with open government data feeds.',
    tech: [{ label: 'Laravel', cls: 'laravel-label' }, { label: 'Open Data API', cls: 'react-label' }, { label: 'PHP', cls: 'php-label' }],
    date: '02 Oct 2017',
    year: '2017',
    img: AirPollutionImg,
    demo: 'https://www.tekdig.com/check-pollution/',
  },
  {
    title: 'Angular2 Google Login',
    category: 'plugin',
    categoryLabel: 'Plugin',
    desc: 'Google OAuth 2.0 authentication provider module built for Angular2 single-page applications.',
    tech: [{ label: 'TypeScript', cls: 'ts-label' }, { label: 'Angular2', cls: 'react-label' }, { label: 'OAuth 2.0', cls: 'laravel-label' }],
    date: '05 May 2017',
    year: '2017',
    img: Angular2GoogleLoginImg,
    demo: 'http://content.rudrakshpathak.com/angular2-google-login',
    github: 'https://github.com/rudrakshpathak/angular2-google-login',
    npm: 'https://www.npmjs.com/package/angular2-google-login',
  },
  {
    title: 'E.P.I.C. Gesture System',
    category: 'application',
    categoryLabel: 'Application',
    desc: 'A gesture-based interface leveraging LeapMotion emulation to assemble virtual machinery with spatial interactions.',
    tech: [{ label: 'JavaScript', cls: 'js-label' }, { label: 'LeapMotion', cls: 'ts-label' }],
    date: '16 Feb 2016',
    year: '2016',
    pending: true,
    icon: 'gesture',
    github: 'https://github.com/rudrakshpathak/Swap-Grab-LeapMotion-Gestures',
    details: 'Built during university as an experimental HCI project. Users manipulate virtual components using hand gestures captured via LeapMotion sensors, demonstrating spatial interaction patterns for assembly-line simulations.',
  },
  {
    title: 'Video Sharing Platform',
    category: 'application',
    categoryLabel: 'Application',
    desc: 'Web-based video distribution system allowing content creators to upload, stream, and categorize short videos.',
    tech: [{ label: 'PHP', cls: 'php-label' }, { label: 'MySQL', cls: 'react-label' }, { label: 'HTML5', cls: 'html-label' }],
    date: '02 May 2015',
    year: '2015',
    pending: true,
    icon: 'video',
    details: 'Early-stage video platform with upload workflows, category tagging, and streaming playback. Designed for short-form content distribution within an academic environment.',
  },
  {
    title: 'Online Examination System',
    category: 'application',
    categoryLabel: 'Application',
    desc: 'Online examination portal for faculties to author questions, conduct time-bound tests, and generate automated analytics.',
    tech: [{ label: 'PHP', cls: 'php-label' }, { label: 'MySQL', cls: 'react-label' }, { label: 'Bootstrap', cls: 'css-label' }],
    date: '01 Mar 2015',
    year: '2015',
    pending: true,
    icon: 'exam',
    details: 'Full-featured exam portal supporting question banks, timed assessments, auto-grading for objective questions, and result analytics dashboards for faculty review.',
  },
  {
    title: 'Inventory Management System',
    category: 'application',
    categoryLabel: 'Application',
    desc: 'Asset tracking and warehouse inventory management system for monitoring enterprise stock levels.',
    tech: [{ label: 'PHP', cls: 'php-label' }, { label: 'MySQL', cls: 'react-label' }, { label: 'jQuery', cls: 'jquery-label' }],
    date: '01 Jan 2015',
    year: '2015',
    pending: true,
    icon: 'inventory',
    details: 'Enterprise inventory tracker with stock in/out logging, low-stock alerts, supplier records, and reporting views for warehouse operations.',
  },
];

const categories = [
  { key: 'all', label: 'All' },
  { key: 'application', label: 'Applications' },
  { key: 'plugin', label: 'Plugins' },
];

const filterProject = (project, activeCategory, query) => {
  const matchesCategory =
    activeCategory === 'all' || project.category === activeCategory;
  const matchesSearch =
    !query ||
    project.title.toLowerCase().includes(query) ||
    project.desc.toLowerCase().includes(query) ||
    project.tech.some((t) => t.label.toLowerCase().includes(query));
  return matchesCategory && matchesSearch;
};

class Showcase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategory: 'all',
      searchQuery: '',
      selectedProject: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = '';
  }

  handleKeyDown = (e) => {
    if (e.key === 'Escape') this.closeModal();
  };

  setCategory = (cat) => this.setState({ activeCategory: cat });

  handleSearchChange = (e) => this.setState({ searchQuery: e.target.value });

  clearSearch = () => this.setState({ searchQuery: '' });

  openModal = (project) => {
    this.setState({ selectedProject: project });
    document.body.style.overflow = 'hidden';
  };

  closeModal = () => {
    this.setState({ selectedProject: null });
    document.body.style.overflow = '';
  };

  buildLinks = (project) => {
    const links = [];
    if (project.demo) {
      links.push({ href: project.demo, label: 'Live Demo', icon: 'fa fa-external-link', primary: true });
    }
    if (project.github) {
      links.push({ href: project.github, label: 'GitHub', icon: 'fa fa-github' });
    }
    if (project.npm) {
      links.push({ href: project.npm, label: 'npm', icon: 'fa fa-cube' });
    }
    return links;
  };

  renderLiveCard = (project, idx) => (
    <ContentLiveCard
      key={project.title}
      img={project.img}
      badge={project.categoryLabel}
      year={project.year}
      title={project.title}
      desc={project.desc}
      techTags={project.tech}
      links={this.buildLinks(project)}
      delay={idx * 80}
    />
  );

  renderArchiveTile = (project, idx) => (
    <button
      type="button"
      className="sc-archive-tile animate-fade-in"
      key={project.title}
      style={{ animationDelay: `${idx * 60}ms` }}
      onClick={() => this.openModal(project)}
      aria-label={`View details for ${project.title}`}
    >
      <div className={`sc-archive-icon sc-archive-icon--${project.icon}`}>
        {conceptIcons[project.icon]}
      </div>
      <div className="sc-archive-info">
        <span className="sc-archive-year">{project.year}</span>
        <h3 className="sc-archive-title">{project.title}</h3>
        <span className="sc-archive-cta">View details <i className="fa fa-arrow-right"></i></span>
      </div>
    </button>
  );

  renderModal = () => {
    const { selectedProject } = this.state;
    if (!selectedProject) return null;

    return (
      <div className="sc-modal-overlay" onClick={this.closeModal} role="presentation">
        <div
          className="sc-modal animate-fade-in"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="sc-modal-title"
        >
          <button type="button" className="sc-modal-close" onClick={this.closeModal} aria-label="Close">
            <i className="fa fa-times"></i>
          </button>

          <div className="sc-modal-layout">
            <div className={`sc-modal-visual sc-modal-visual--${selectedProject.icon}`}>
              {conceptIcons[selectedProject.icon]}
            </div>

            <div className="sc-modal-body">
              <div className="sc-modal-meta">
                <span className="sc-type-badge">{selectedProject.categoryLabel}</span>
                <span className="sc-year">{selectedProject.date}</span>
              </div>
              <h2 id="sc-modal-title" className="sc-modal-title">{selectedProject.title}</h2>
              <p className="sc-modal-desc">{selectedProject.details || selectedProject.desc}</p>

              <div className="sc-tech-tags sc-modal-tags">
                {selectedProject.tech.map((t, i) => (
                  <span className={`label ${t.cls}`} key={i}>{t.label}</span>
                ))}
              </div>

              {selectedProject.github && (
                <a
                  href={selectedProject.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary sc-modal-github"
                >
                  <i className="fa fa-github"></i> View Source
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { activeCategory, searchQuery } = this.state;
    const query = searchQuery.trim().toLowerCase();

    const filtered = projects.filter((p) => filterProject(p, activeCategory, query));
    const liveProjects = filtered.filter((p) => !p.pending);
    const archiveProjects = filtered.filter((p) => p.pending);

    const liveCount = projects.filter((p) => !p.pending).length;
    const archiveCount = projects.filter((p) => p.pending).length;
    const npmCount = projects.filter((p) => p.npm).length;

    return (
      <div className="showcase-page content-page">
        <Header />

        <main id="main-content" className="section-wrapper">
          <PageTitle
            eyebrow="Selected Work"
            pageTitle="Project Showcase"
            subtitle="Software applications, open-source packages, and developer tools built over the past decade."
          />

          <ContentStatsBar stats={[
            { value: liveCount, label: 'Live Demos' },
            { value: npmCount, label: 'npm Packages' },
            { value: archiveCount, label: 'Archive' },
          ]} />

          <div className="showcase-controls">
            <div className="filter-pill-bar">
              {categories.map((cat) => {
                const count =
                  cat.key === 'all'
                    ? projects.length
                    : projects.filter((p) => p.category === cat.key).length;
                if (count === 0) return null;
                return (
                  <button
                    key={cat.key}
                    type="button"
                    className={`filter-pill-btn ${activeCategory === cat.key ? 'active' : ''}`}
                    onClick={() => this.setCategory(cat.key)}
                  >
                    {cat.label}
                    <span className="pill-count">{count}</span>
                  </button>
                );
              })}
            </div>

            <div className="search-input-wrap">
              <i className="fa fa-search search-icon"></i>
              <input
                type="text"
                placeholder="Search projects or tech..."
                value={searchQuery}
                onChange={this.handleSearchChange}
                className="search-input"
              />
              {searchQuery && (
                <button type="button" onClick={this.clearSearch} className="search-clear-btn" title="Clear">
                  <i className="fa fa-times"></i>
                </button>
              )}
            </div>
          </div>

          {filtered.length > 0 ? (
            <div className="sc-sections">
              {liveProjects.length > 0 && (
                <section className="sc-section">
                  <header className="sc-section-header">
                    <h2 className="sc-section-title">Live &amp; Open Source</h2>
                    <p className="sc-section-desc">Projects with working demos and published packages.</p>
                  </header>
                  <div className="sc-live-stack">
                    {liveProjects.map((p, i) => this.renderLiveCard(p, i))}
                  </div>
                </section>
              )}

              {archiveProjects.length > 0 && (
                <section className="sc-section">
                  <header className="sc-section-header">
                    <h2 className="sc-section-title">Early Work</h2>
                    <p className="sc-section-desc">University and early-career projects — select any to learn more.</p>
                  </header>
                  <div className="sc-archive-grid">
                    {archiveProjects.map((p, i) => this.renderArchiveTile(p, i))}
                  </div>
                </section>
              )}
            </div>
          ) : (
            <div className="showcase-empty-state animate-fade-in">
              <i className="fa fa-folder-open-o empty-icon"></i>
              <h3>No matching projects</h3>
              <p>Try a different search term or category.</p>
              <button
                type="button"
                onClick={() => this.setState({ searchQuery: '', activeCategory: 'all' })}
                className="btn-primary"
              >
                Reset Filters
              </button>
            </div>
          )}
        </main>

        {this.renderModal()}
        <Footer />
      </div>
    );
  }
}

export default Showcase;
